import React, { Suspense, useEffect, useMemo, useState } from "react";
import { getDataFromHomePageApi, type ApiComponent } from "../../lib/api";
import PreLoader from "../../components/preloader/PreLoader";

const LAZY_COMPONENTS: Record<
  string,
  () => Promise<{ default: React.ComponentType<any> }>
> = {
  BannerServices: () =>
    import("../../components/bannerServices/BannerServicesNew"),
  VisasuggestCarousel: () =>
    import("../../components/homeNew/VisasuggestCarousel"),
  CustomerHappiness: () =>
    import("../../components/homeNew/CustomerHappinessCards"),
  PromoBanner: () => import("../../components/homeNew/PromoBanner"),
  NewServices: () => import("../../components/homeNew/NwServices"),
  ServiceDetailBanner: () =>
    import("../../components/serviceDetails/ServiceDetailBanner"),
  AllServices: () =>
    import("../../pages/Department/AllSubComponents/AllServices"),
  AboutDepartment: () =>
    import("../../pages/Department/AllSubComponents/AboutDepartment"),
  AllVisa: () => import("../../pages/Department/AllSubComponents/PackagesCard"),
  VisaProcess: () =>
    import("../../pages/Department/AllSubComponents/VisaProcess"),
  VisaFactors: () =>
    import("../../pages/Department/AllSubComponents/VisaFactors"),
  CommonVisaInfo: () =>
    import("../../pages/Department/AllSubComponents/CommonVisaInfo"),
  DepartmentRejection: () =>
    import("../../pages/Department/AllSubComponents/DepartmentRejection"),
  CenterDetails: () =>
    import("../../pages/Department/AllSubComponents/CenterDetails"),
  ChannelPartner: () =>
    import("../../pages/Department/AllSubComponents/ChannelPartner"),
  TrustedFactor: () =>
    import("../../pages/Department/AllSubComponents/TrustedFactor"),
  WhyChooseUs: () =>
    import("../../pages/Department/AllSubComponents/WhyChooseUs"),
  AuthorizedPartner: () =>
    import("../../pages/Department/AllSubComponents/AuthorizedPartner"),
  VisaRequirement: () =>
    import("../../pages/Department/AllSubComponents/VisaRequirement"),
  ServiceEmirate: () =>
    import("../../pages/Department/AllSubComponents/DepartmentEmirate"),
  FaqDepartment: () =>
    import("../../pages/Department/AllSubComponents/FaqDepartment"),
  Employees: () => import("../../pages/Department/AllSubComponents/Employees"),
  Certificate: () => import("../../components/Certificates/Certificate"),
};

interface HomeNewProps {
  pageUrl?: string;
}

const HomeNew: React.FC<HomeNewProps> = ({ pageUrl }) => {
  const [items, setItems] = useState<ApiComponent[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const urlParam = useMemo(() => {
    const raw =
      pageUrl ??
      (typeof window !== "undefined" ? window.location.pathname : "/");
    return raw || "/";
  }, [pageUrl]);

  useEffect(() => {
    const controller = new AbortController();

    (async () => {
      setLoading(true);

      setErr(null);
      try {
        const components = await getDataFromHomePageApi(controller.signal);

        if (!components) {
          setItems([]);
          return;
        }
        setItems(components);
        // const sorted = [...components].sort((a, b) => {
        //   const ap =
        //     a.section_position ??
        //     a.props?.info?.section_position ??
        //     Number.MAX_SAFE_INTEGER;
        //   const bp =
        //     b.section_position ??
        //     b.props?.info?.section_position ??
        //     Number.MAX_SAFE_INTEGER;
        //   return ap - bp;
        // });

        // setItems(sorted);
      } catch (e: any) {
        if (e?.name !== "CanceledError") {
          setErr(e?.message || "Failed to load");
        }
      } finally {
        setLoading(false);
      }
    })();

    return () => controller.abort();
  }, [urlParam]);

  if (loading && !items) return <PreLoader />;
  if (err) return <div style={{ color: "crimson" }}>Error: {err}</div>;

  return (
    <>
      {items &&
        items.map((block, idx) => {
          const loader = LAZY_COMPONENTS[block.name];
          if (!loader) {
            console.warn(`No component registered for "${block.name}"`);
            return null;
          }
          const Cmp = React.lazy(loader);

          return (
            <div className="HomeNew">
              <Suspense fallback={<PreLoader />} key={`${block.name}-${idx}`}>
                <Cmp {...block.props} />
              </Suspense>
            </div>
          );
        })}
    </>
  );
};

export default HomeNew;
